import earmarkElbaApi from "@/api/earmark/earmarkElbaApi";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getReportData({dispatch}, {orderSetId}) {
      try {
        const response = await earmarkElbaApi.fetchReportData(orderSetId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
